import { CashTransactionModel } from 'api-hooks/transactions/cash-transaction';
import React from 'react';

import { CashTransactionFormType } from '../components/form-type';

export default function useGetDefaultValues(
  cashTransaction?: CashTransactionModel,
) {
  const defaultValues = React.useMemo<CashTransactionFormType>(() => {
    return {
      transactionCategoryId: cashTransaction?.transactionCategory?.id || null,
      transactionAt: cashTransaction?.transactionAt || new Date(),
      tempTransactionAt: cashTransaction?.transactionAt || new Date(),
      needApproval: false,
      cashAccountId: cashTransaction?.cashAccount.id || null,
      type: cashTransaction?.type || null,
      amount: cashTransaction?.amount || 0,
      description: cashTransaction?.description || '',
      number: cashTransaction?.number,
      refId: cashTransaction?.refId,
    };
  }, [cashTransaction]);

  return defaultValues;
}
